// components/Topbar.js
import React, { useEffect, useState } from "react";
import "../styles/Topbar.css";

const Topbar = ({ onMenuClick }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("user");
      if (stored) setUser(JSON.parse(stored));
    } catch {
      setUser(null);
    }
  }, []);

  // Optional: derive location (placeholder if not set)
  const location = user?.location || "📍 Global User";

  return (
    <div className="topbar">
      <div className="left-section">
        <button className="menu-toggle" onClick={onMenuClick}>
          <img src="/menu.svg" alt="Sidebar Options" />
          <span className="menu-label">Options</span>
        </button>
      </div>

      <div className="topbar-user">
        <p>{user?.name || "Guest User"}</p>
        <span>{location}</span>
      </div>
    </div>
  );
};

export default Topbar;